const OFFICE_API_ORIGINS = {
  development: 'https://office-api-dev.hkmeeting.net',
  test: 'https://office-api-test.hkmeeting.org',
  production: 'https://office-api.hkmeeting.ai',
} as const;

const environment = (process.env.CUR_ENV || 'development') as keyof typeof OFFICE_API_ORIGINS;
const selectedOrigin = Object.prototype.hasOwnProperty.call(OFFICE_API_ORIGINS, environment) ? OFFICE_API_ORIGINS[environment] : OFFICE_API_ORIGINS.development;

// Deployed frontends keep their existing same-origin API routing.
export const OFFICE_API_ORIGIN = process.env.NODE_ENV === 'production' ? '' : selectedOrigin;

export const officeUrl = (path: string): string => {
  if (/^https?:\/\//i.test(path) || !OFFICE_API_ORIGIN) {
    return path;
  }
  return new URL(path, `${OFFICE_API_ORIGIN}/`).href;
};

// Accept relative and absolute wire URLs only within the expected Office route.
export const isOfficePath = (value: string, path: string, exact = false): boolean => {
  try {
    const base = typeof window === 'undefined' ? 'http://localhost' : window.location?.origin || 'http://localhost';
    const expected = new URL(officeUrl(path), base);
    const parsed = new URL(officeUrl(value), base);
    return parsed.origin === expected.origin && !parsed.username && !parsed.password && (exact ? parsed.href === expected.href : parsed.href.startsWith(expected.href));
  } catch {
    return false;
  }
};
